/**
 * Scene for displaying terminal errors to the user.
 * @module Terminator
 * @class Terminator
 * @extends Phaser.Scene
 */

const Terminator = new Phaser.Class( {
    Extends: Phaser.Scene,
    initialize: function Level () {
        Phaser.Scene.call( this, {
            key: "terminator",
            active: false,
            visible: false,
        } );
    },

    create: function () {

        // Remove current level.
        this.game.levelManager.getCurrent().scene.stop();

        // Set level background color to dark green.
        this.cameras.main.setBackgroundColor( {
            r: 16,
            g: 32,
            b: 16,
            a: 255,
        } );

        let message = this.game.userErrorMessage || "An unexpected error occurred. If we'd expected this, it wouldn't be unexpected.";
        if ( typeof window.reportError === "function" ) {
            window.reportError( message );
        }

        // Set up feedback text.
        this.text = this.add.text( 10, 20, "" );
        this.text.setColor( "#aaffaa" );
        this.text.setWordWrapWidth( this.game.canvas.width - 20 );

        // Set up typewriter effect.
        const step = 2;
        const doNext = () => {
            if ( message.length ) {
                const newText = message.slice( 0, step );
                this.text.setText( this.text.text + newText );
                message = message.slice( step );
                setTimeout( doNext, 1 );
            }
        };
        doNext();
    },
} );

export default Terminator;
